export default __webpack_public_path__ + "static/media/modulo-3.1266db59.svg";